module.exports = __webpack_public_path__ + "static/media/Pres_1.b696180a.png";